import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

const DeleteLeaveModal = ({ show, handleClose, data }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body
        style={{
          textAlign: "center",
          padding: "30px 20px",
        }}
      >
        {/* ICON */}
        <div
          style={{
            width: "70px",
            height: "70px",
            margin: "0 auto 20px",
            backgroundColor: "#f8d7da",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FiTrash2 size={32} color="#dc3545" />
        </div>

        {/* TITLE */}
        <h4
          style={{
            fontWeight: "600",
            marginBottom: "10px",
            color: "#2f3b52",
          }}
        >
          Confirm Delete
        </h4>

        {/* DESCRIPTION */}
        <p
          style={{
            color: "#6c757d",
            fontSize: "14px",
            marginBottom: "25px",
            lineHeight: "1.5",
          }}
        >
          You want to delete all the marked items, this cant be
          <br />
          undone once you delete.
        </p>

        {/* BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <Button
            onClick={handleClose}
            style={{
              backgroundColor: "#f1f3f5",
              border: "1px solid #dee2e6",
              color: "#495057",
              padding: "8px 18px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            Cancel
          </Button>

          <Button
            style={{
              backgroundColor: "#e03131",
              border: "none",
              padding: "8px 18px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteLeaveModal;